import { makeStyles } from '@mui/styles'
import { app } from '../../theme/themevars'

const useStyles = makeStyles((theme) => ({
  drawer: {
    backgroundColor: theme?.custom?.components.mainNavigationDrawer.backgroundColor,
    flexShrink: 0,
    overflowX: 'hidden',
    [theme.breakpoints.down('sm')]: {
      maxWidth: app.drawer.mobileMaxWidth,
    },
    [theme.breakpoints.up('sm')]: {
      borderRadius: theme?.custom?.components.mainNavigationDrawer.borderRadius,
      whiteSpace: 'nowrap',
      width: app.drawer.mainNavigationWidth,
      transition: theme.transitions.create('background-color', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.shortest,
      }),
    },
  },
  drawerOpen: {
    [theme.breakpoints.up('sm')]: {
      backgroundColor: theme?.custom?.components.mainNavigationDrawer.open.backgroundColor,
      width: app.drawer.mainNavigationWidthOpen,
    },
  },
  drawerPaper: {
    borderRight: 0,
    overflowX: 'inherit',
    width: '100%',
    maxWidth: 'inherit',
    [theme.breakpoints.up('sm')]: {
      borderRadius: 'inherit',
      backgroundColor: 'inherit',
      width: 'inherit',
      transition: theme.transitions.create(['width', 'box-shadow'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.shortest,
      }),
    },
  },
  [theme.breakpoints.down('sm')]: {
    toolBar: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
    },
    iconButtonClose: {
      marginRight: theme.spacing(1),
    },
  },
  [theme.breakpoints.up('sm')]: {
    drawerPusher: theme.mixins.toolbar,
  },
}))

export default useStyles
